const css = `.expense-calendar-event {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px;
  height: 100%;
  min-height: 24px;
  overflow: hidden;
  border-radius: var(--border-radius);
  border: 1px solid;
}
.expense-calendar-event .event-type {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  border-radius: 4px;
  flex-shrink: 0;
  color: var(--surface-0);
}
.expense-calendar-event .event-type i {
  font-size: var(--font-size-sm);
}
.expense-calendar-event .event-content {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  min-height: 24px;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-tight);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.expense-calendar-event .event-content .amount {
  color: var(--text);
  font-weight: var(--font-weight-medium);
}
.expense-calendar-event .event-content span {
  color: var(--text);
}
.expense-calendar-event.cash .event-type {
  background-color: var(--success);
}
.expense-calendar-event.cash .event-content {
  background-color: var(--success-subtle);
}
.expense-calendar-event.card .event-type {
  background-color: var(--info);
}
.expense-calendar-event.card .event-content {
  background-color: var(--info-subtle);
}
.expense-calendar-event.bonus .event-type {
  background-color: var(--accent);
}
.expense-calendar-event.bonus .event-content {
  background-color: var(--accent-subtle);
}
@media screen and (max-width: 576px) {
  .expense-calendar-event {
    padding: 2px;
    gap: 2px;
    min-height: 20px;
  }
  .expense-calendar-event .event-type {
    display: none;
  }
  .expense-calendar-event .event-content {
    padding: 2px 4px;
    min-height: 18px;
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    border-radius: 3px;
  }
  .expense-calendar-event .event-content .amount::before {
    content: attr(data-currency);
    margin-right: 2px;
  }
  .expense-calendar-event.cash .event-content {
    border-left: 2px solid var(--success);
  }
  .expense-calendar-event.card .event-content {
    border-left: 2px solid var(--info);
  }
  .expense-calendar-event.bonus .event-content {
    border-left: 2px solid var(--accent);
  }
}

.expense-tooltip {
  min-width: 180px;
  padding: 8px;
  background-color: var(--surface-0);
  border: 1px solid var(--surface-200);
  box-shadow: 0 2px 4px var(--shadow-2);
}
.expense-tooltip .expense-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.expense-tooltip .expense-header i {
  font-size: var(--font-size-base);
}
.expense-tooltip .expense-header .amount {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
}
.expense-tooltip .expense-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.expense-tooltip .expense-details .detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.expense-tooltip .expense-details .detail-item i {
  font-size: var(--font-size-sm);
  color: var(--text-color-secondary);
}
.expense-tooltip .expense-details .detail-item span {
  font-size: var(--font-size-xs);
  color: var(--text-color-secondary);
}
@media screen and (max-width: 576px) {
  .expense-tooltip {
    min-width: 160px;
    padding: 8px;
  }
  .expense-tooltip .expense-header {
    gap: 8px;
    margin-bottom: 8px;
  }
  .expense-tooltip .expense-header i {
    font-size: var(--font-size-sm);
  }
  .expense-tooltip .expense-header .amount {
    font-size: var(--font-size-xs);
  }
  .expense-tooltip .expense-details {
    gap: 4px;
  }
  .expense-tooltip .expense-details .detail-item {
    gap: 4px;
  }
  .expense-tooltip .expense-details .detail-item i {
    font-size: var(--font-size-xs);
  }
  .expense-tooltip .expense-details .detail-item span {
    font-size: var(--font-size-xs);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
